import ControlBtn from '@components/controlBtn/controlBtn.js';
import storage from '@app/storage.js';

import * as styles from './audio.module.scss';

import empty from './audio/empty.wav';
import filled from './audio/filled.mp3';
import nothing from './audio/nothing.wav';
import win from './audio/win.wav';

const SOUND_TEXT = 'Sound_ON';
const NO_SOUND_TEXT = 'Sound_OFF';

class AudioPlayer {
  /** @type {ControlBtn} */
  control;
  /** @type {HTMLAudioElement} */
  empty;
  /** @type {HTMLAudioElement} */
  filled;
  /** @type {HTMLAudioElement} */
  nothing;
  /** @type {HTMLAudioElement} */
  win;
  /** @type {boolean} */
  isSound;

  constructor() {
    this.isSound = true;
    this.addSounds();
    this.createControl();

    window.addEventListener(
      'custom:applySound',
      /** @type {EventListener} */ (this.handleChangeSound)
    );
    window.addEventListener(
      'custom:showWinMessage',
      /** @type {EventListener} */ (this.playWin.bind(this))
    );
  }

  /**
   * Handles sound toggles from controller.
   * @param {CustomEvent<{isSound: boolean}>} e
   * @returns {void}
   */
  handleChangeSound = (e) => {
    this.isSound = e.detail.isSound;
    this.control.setText(this.isSound ? SOUND_TEXT : NO_SOUND_TEXT);
  };

  /**
   * Plays marked empty sound.
   * @returns {void}
   */
  playEmpty() {
    if (!this.isSound) return;

    this.empty.currentTime = 0;
    this.empty.play();
  }

  /**
   * Plays filled cell sound.
   * @returns {void}
   */
  playFilled() {
    if (!this.isSound) return;

    this.filled.currentTime = 0;
    this.filled.play();
  }

  /**
   * Plays non-marked cell sound.
   * @returns {void}
   */
  playNothing() {
    if (!this.isSound) return;

    this.nothing.currentTime = 0;
    this.nothing.play();
  }

  /**
   * Plays win sound.
   * @returns {void}
   */
  playWin() {
    if (!this.isSound) return;

    this.win.currentTime = 0;
    this.win.play();
  }

  /**
   * Creates an HTMLAudioElement.
   * @param {string} src
   * @returns {HTMLAudioElement}
   * @private
   */
  createSound(src) {
    const sound = new Audio(src);
    sound.volume = 0.3;
    sound.preload = 'auto';
    return sound;
  }

  /**
   * Attaches multiple HTMLAudioElements to the class.
   * @returns {void}
   * @private
   */
  addSounds() {
    this.empty = this.createSound(empty);
    this.filled = this.createSound(filled);
    this.nothing = this.createSound(nothing);
    this.win = this.createSound(win);
  }

  /**
   * Creates control button.
   * @returns {void}
   * @private
   */
  createControl() {
    const text = this.isSound ? SOUND_TEXT : NO_SOUND_TEXT;
    this.control = new ControlBtn({ text, classes: [styles.control] });
    this.control.addListener('click', this.toggleMute);
  }

  /**
   * Toggles sound on / off.
   * @returns {any}
   * @private
   */
  toggleMute = () => {
    this.isSound = !this.isSound;
    storage.setItem('isSound', this.isSound);

    if (this.isSound) this.control.setText(SOUND_TEXT);
    else this.control.setText(NO_SOUND_TEXT);
  };
}
export default new AudioPlayer();
